import './moment'

let user = JSON.parse(localStorage.getItem('user'))
let bearer = null
if (user && moment.utc(user.expires_at).diff(moment()) <= 0) {
    localStorage.removeItem('user')
    bearer = false
} else {
    bearer = user && user.access_token ? user.access_token : false
}

export const USER = user
export const BEARER = bearer
